import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/I18nContext";

export default function Footer() {
  const { t, lang } = useI18n();
  const base = `/${lang}`;
  const year = 2026;

  return (
    <footer
      className="bg-[#0F172A] text-slate-300"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <span className="inline-flex h-9 w-9 items-center justify-center bg-white text-[#0F172A] font-bold">
              M
            </span>
            <span className="font-heading text-2xl text-white tracking-tight">
              {t("brand.name")}
            </span>
          </div>
          <p className="text-sm leading-relaxed text-slate-400 max-w-md">
            {t("footer.brand_desc")}
          </p>
          <p className="text-xs leading-relaxed text-slate-500 mt-6 max-w-md">
            {t("footer.risk_notice")}
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#B48E5D] font-bold mb-4">
            {t("footer.company_title")}
          </h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li data-testid="footer-legal-company-name">
              {t("footer.legal.company_name")}
            </li>
            <li data-testid="footer-legal-registration">
              {t("footer.legal.registration")}
            </li>
            <li data-testid="footer-legal-tax">
              {t("footer.legal.tax_id")}
            </li>
            <li data-testid="footer-legal-license">
              {t("footer.legal.license")}
            </li>
            <li data-testid="footer-legal-jurisdiction">
              {t("footer.legal.jurisdiction")}
            </li>
            <li data-testid="footer-legal-incorporated">
              {t("footer.legal.incorporated")}
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#B48E5D] font-bold mb-4">
            {t("footer.legal_title")}
          </h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                to={`${base}/privacy`}
                className="text-slate-300 hover:text-white"
                data-testid="footer-link-privacy"
              >
                {t("footer.privacy")}
              </Link>
            </li>
            <li>
              <Link
                to={`${base}/cookies`}
                className="text-slate-300 hover:text-white"
                data-testid="footer-link-cookies"
              >
                {t("footer.cookies")}
              </Link>
            </li>
            <li>
              <Link
                to={`${base}/terms`}
                className="text-slate-300 hover:text-white"
                data-testid="footer-link-terms"
              >
                {t("footer.terms")}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 text-xs text-slate-500 flex flex-col md:flex-row md:justify-between gap-2">
          <span data-testid="footer-copyright">
            © {year} {t("footer.legal.company_name")}. {t("footer.rights")}
          </span>
          <span>metrosenda.com</span>
        </div>
      </div>
    </footer>
  );
}
